import React from 'react';
import CargaTarjeta from '../../comun/CargaTarjeta';

/**
 * Tarjeta «Sueldos y pensiones» del AT 2026: el Excel «Detalle_DJ_1887» que el SII
 * entrega a la persona en Información de terceros. Su lector está en
 * src/services/declaracionRenta/empresarioIndividual/2026/sueldos/lector.js
 */
const COLUMNAS = [
  { campo: 'nombre_declarante', titulo: 'Empleador' },
  { campo: 'rut_declarante', titulo: 'RUT empleador' },
  { campo: 'renta_neta', titulo: 'Renta neta', monto: true },
  { campo: 'impuesto_unico_retenido', titulo: 'Impuesto único retenido', monto: true },
  { campo: 'mayor_retencion', titulo: 'Mayor retención', monto: true },
  { campo: 'renta_no_gravada', titulo: 'Renta no gravada', monto: true },
  { campo: 'renta_exenta', titulo: 'Renta exenta', monto: true },
  { campo: 'numero_certificado', titulo: 'N° certificado' },
  { campo: 'estado_sii', titulo: 'Estado SII' },
];

const SueldosPage = ({ anioTributario, idCompany }) => (
  <CargaTarjeta
    anioTributario={anioTributario}
    idCompany={idCompany}
    tarjeta="sueldos"
    columnas={COLUMNAS}
    extensiones=".xls,.xlsx"
    ayuda={(
      <>
        Sube el Excel <strong>Detalle_DJ_1887_{anioTributario}00_&lt;RUT&gt;.xlsx</strong> que descargas del SII en
        Información de terceros: los sueldos que informó cada empleador (montos anuales actualizados). El resumen
        «DJ_1887_{anioTributario}_…» no se sube. El archivo no se guarda.
      </>
    )}
  />
);

export default SueldosPage;
